"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useAppStore } from "@/store/appStore";
import { getUTMData } from "@/lib/utils/utm-tracker";
import { updateUserData } from "@/app/product/_actions/user.actions";

export const REFERRAL_STORAGE_KEY = "referral_token";

export default function UTMTracker() {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const { data } = useAppStore();
	const authorization = data?.authorization;
	const lastTrackedCampaign = useRef<string | null>(null);

	// Capture ?ref= param into sessionStorage for onboarding auto-fill
	useEffect(() => {
		const ref = searchParams.get("ref");
		if (ref) {
			sessionStorage.setItem(REFERRAL_STORAGE_KEY, ref);
		}
	}, [searchParams]);

	useEffect(() => {
		const trackUTM = async () => {
			if (!authorization) return;

			const utmData = getUTMData();
			if (!utmData) return;

			const campaignKey = `${utmData.utm_source}-${utmData.utm_campaign}`;
			if (lastTrackedCampaign.current === campaignKey) {
				return;
			}

			try {
				const result = await updateUserData({ utmData });
				if (result) {
					// ← Check if user was returned
					lastTrackedCampaign.current = campaignKey;
				}
			} catch (error) {
				console.error("UTM tracking error:", error);
			}
		};

		trackUTM();
	}, [pathname, authorization]);

	return null;
}
